import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { withWrapper } from "create-react-server/wrapper";

import article from "modules/article";
import "./Article.css";

class Article extends Component {
  constructor(props) {
    super(props);
    props.getArticle(props.match.params.id);
    if (typeof window !== "undefined") window.scrollTo(0, 0);
    this.parseText = this.parseText.bind(this);
  }

  componentWillMount() {
    this.props.clearArticle();
  }

  parseText(text) {
    if (text && this.refs.text) {
      this.refs.text.innerHTML = text;
    }
  }

  render() {
    return (
      <div className="content">
        <div>
          <div className="article">
            <Link
              to={{ pathname: "/articles/" + this.props.article.rubric }}
              className="rubric margin-normal"
            >
              {this.props.article.subject
                ? this.props.article.subject[0].toUpperCase() +
                  this.props.article.subject.slice(1)
                : ""}
            </Link>
            <div
              className="artical-title"
              dangerouslySetInnerHTML={{ __html: this.props.article.title }}
            />
            {this.props.article.image ? (
              <div
                className={`margin-normal height-${
                  this.props.article.height_style
                }`}
              >
                <img
                  className="image"
                  src={`${process.env.REACT_APP_IMG_SERVER}/img/${
                    this.props.article.image
                  }/mobile`}
                  alt=""
                />
              </div>
            ) : (
              ""
            )}
            <div ref="text">{this.parseText(this.props.article.text)}</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  article: state.article.article
});

const mapDispatchToProps = dispatch => ({
  getArticle: bindActionCreators(article.actions.getArticle, dispatch),
  clearArticle: bindActionCreators(article.actions.clearArticle, dispatch)
});

export default withWrapper(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Article)
);



// WEBPACK FOOTER //
// ./src/components/Article/Article.js